var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "create-iybr-wrapper",
    },
    [
      _c(
        "pui-lightbox",
        {
          ref: _vm.SUBMIT_LOADING_MODAL,
          attrs: {
            fullscreen: true,
          },
        },
        [
          _c(
            "p",
            {
              attrs: {
                slot: "default",
              },
              slot: "default",
            },
            [
              _c("pui-loader-spinner", {
                attrs: {
                  message: "Change request is being submitted.",
                  "min-height": "500px",
                  title: "Please wait!",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "pui-grid-container",
        [
          _c(
            "pui-grid-row",
            [
              _c(
                "pui-grid-column",
                [
                  _c("pui-breadcrumb", {
                    attrs: {
                      links: _vm.breadcrumbLinks,
                    },
                    on: {
                      "changed:active-route": _vm.onBreadcrumbLinkClick,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.isSubmmitedSuccessfully
            ? _c(
                "div",
                [
                  _c(
                    "pui-grid-row",
                    [
                      _c(
                        "pui-grid-column",
                        {
                          attrs: {
                            cols: {
                              s: 12,
                              m: 12,
                              l: 8,
                              xl: 8,
                            },
                          },
                        },
                        [
                          _c(
                            "pui-headline",
                            {
                              staticClass: "iybr-headline",
                              attrs: {
                                type: "h3",
                              },
                            },
                            [_vm._v(" New Change Request ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("create-iybr-form", {
                    ref: "form",
                    on: {
                      "currently-submitting": _vm.openLoadingScreen,
                      "error-submitting": _vm.handleSubmitError,
                      "iybr-form-submitted": _vm.onFormSubmit,
                    },
                  }),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("iybr-form-submit-confirmation", {
                    attrs: {
                      "unique-id": _vm.miniFdUniqueId,
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }